import React from "react";
import Dashboard from "../Pages/DashBoard/Dashboard";

/** App home ("/"): Dashboard for all viewports. */
export default function HomeEntry() {
  return <Dashboard />;
}
